export default __webpack_public_path__ + "static/media/brownrocks.217a726f.png";